// src/components/PrivySessionBridge.jsx
// Mantiene en sync la sesión de Privy con la sesión de la app. Cuando el usuario
// hace logout en Bitplify (AuthContext.user → null tras haber estado logueado),
// también cerramos Privy. Sin esto, la wallet anterior quedaría "conectada" y un
// siguiente login por wallet en el mismo navegador firmaría con ESA wallet.
//
// Se monta SOLO cuando hay PrivyProvider (App ID configurado) — usa usePrivy().
import { useEffect, useRef } from 'react';
import { usePrivy, useModalStatus } from '@privy-io/react-auth';
import { useAuth } from '../Context/AuthContext';

export default function PrivySessionBridge() {
  const { user } = useAuth();
  const { ready, authenticated, logout: privyLogout } = usePrivy();
  const { isOpen: privyModalOpen } = useModalStatus();
  const wasLoggedIn = useRef(false);

  useEffect(() => {
    if (user) { wasLoggedIn.current = true; return; }
    // user === null: si veníamos logueados y Privy sigue autenticado, ciérralo.
    if (wasLoggedIn.current && ready && authenticated) privyLogout();
    wasLoggedIn.current = false;
  }, [user, ready, authenticated, privyLogout]);

  // Cuando el modal de Privy está abierto, marcamos el body para OCULTAR el modal
  // de auth de Bitplify (si no, quedan dos modales apilados y se ve raro).
  useEffect(() => {
    document.body.classList.toggle('privy-modal-open', privyModalOpen);
    return () => document.body.classList.remove('privy-modal-open');
  }, [privyModalOpen]);

  return null;
}
